module.exports = __webpack_public_path__ + "static/media/intro.1e55c19d.mp3";